import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import appInitializerReducer from './appInitializerReducer';
import appReducer from './appReducer';
import cropReducer from './cropReducer';
import currentUserReducer from './currentUserReducer';
import featureReducer from './featureReducer';
import farmReducer from './farmReducer';
import fieldReducer from './fieldReducer';
import harvestReducer from './harvestReducer';
import layersReducer from './layersReducer';
import legendReducer from './legendReducer';
import mapReducer from './mapReducer';
import plantingReducer from './plantingReducer';
import seasonReducer from './seasonReducer';
import userReducer from './userReducer';
import weatherReducer from './weatherReducer';
import operationsReducer from './operationsReducer';
import fieldsReducer from './fieldsReducer';
import modalsReducer from './modalReducer';
import scoutingReducer from './scoutingReducer';
import scriptsReducer from './scriptReducer';
import regionReducer from './regionReducer';
import trialRegionReducer from './trialRegionReducer';
import enrollmentStatusReducer from './enrollmentStatusReducer';
import applicationTreatmentReducer from './applicationTreatmentReducer';

const rootReducer = combineReducers({
  routing: routerReducer,
  app: appReducer,
  currentUser: currentUserReducer,
  user: userReducer,
  appInitializer: appInitializerReducer,
  feature: featureReducer,
  farm: farmReducer,
  field: fieldReducer,
  fields: fieldsReducer,
  layers: layersReducer,
  legend: legendReducer,
  seasons: seasonReducer,
  harvest: harvestReducer,
  planting: plantingReducer,
  map: mapReducer,
  crops: cropReducer,
  weather: weatherReducer,
  operations: operationsReducer,
  modal: modalsReducer,
  scouting: scoutingReducer,
  scripts: scriptsReducer,
  region: regionReducer,
  trialRegion: trialRegionReducer,
  enrollmentStatus: enrollmentStatusReducer,
  applicationTreatment: applicationTreatmentReducer
});

export default rootReducer;
